/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export enum StepCodes {
  consents = 'SELF-CONS-PRI',
  documentsRequest = 'SELF-RIC-DOC',
  documentsView = 'SELF-VIEW-DOC',
  additionalDocumentsRequest = 'SELF-ADDRIC-DOC',
  resolution = 'SELF-DATI-ERO',
  quotationCalculation = 'SELF-QUOT-CALC',
  quotation = 'SELF-QUOT-ACC',
  obligations = 'SELF-OBLI-ACC',
  recognition = 'SELF-REMO-RECO',
  adequacy = 'SELF-SURV-ADEG',
  contractSigning = 'SELF-SIGN-DOC',
  waitingLong = 'SELF-WAIT-LONG',
  waitingShort = 'SELF-WAIT-SHORT',
  customerInfo = 'SELF-INFO-CLI',
  financialData = 'SELF-FIN-DATA',
  notes = 'SELF-NOTES',
  tfrRelease = 'SELF-TFR-REL',
  atcChoice = 'SELF-ATC-SEARCH',
  cardConfirm = 'SELF-CARD-CONFIRM',
  dataCollection = 'SELF-DATA-COLL',
  surveyCollection = 'SELF-SURVEY-COLL',
  foreigner = 'SELF-FOREIGNER',
  usesReport = 'SELF-USES-REP',
  withdraw = 'SELF-WITHDRAW',
  instructions = 'SELF-INSTRUCTIONS',
  handoverStart = 'SELF-HANDOVER-START'
}
